import DataProviderStatus from '../enums/DataProviderStatus';

export default class DataProvider {
  constructor(data) {
    this.id = data?.id;
    this.name = data?.name;
    this.status = data?.status ? DataProviderStatus.of(data.status) : DataProviderStatus.ACTIVE;
    this.description = data?.description;
    this.createdAt = data?.createdAt;
    this.updatedAt = data?.updatedAt;
  }
}